import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Tarkista tilaus',
    [StepEnum.OrderPayment]: 'Maksu',
  },
};
